export default [
    {
        path: 'kit-exame',
        component: () => import(
            /* webpackChunkName: 'parametrizacao-kit-exame' */
            '@/views/parametrizacao/kit-exame/Index'
        ),
        redirect: 'kit-exame/index',
        children: [
            {
                name: 'parametrizacao-kit-exame-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'parametrizacao-kit-exame' */
                    '@/views/parametrizacao/kit-exame/List.vue'
                ),
            },
            {
                name: 'parametrizacao-kit-exame-create',
                path: 'create',
                component: () => import(
                    /* webpackChunkName: 'parametrizacao-kit-exame' */
                    '@/views/parametrizacao/kit-exame/Form.vue'
                ),
            },
            {
                name: 'parametrizacao-kit-exame-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'parametrizacao-kit-exame' */
                    '@/views/parametrizacao/kit-exame/Form.vue'
                ),
            },
        ],
    },
]